export default __webpack_public_path__ + "static/media/forgotten-password.486e9922.png";